import React from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Button, Box } from "@mui/material";

const Page404 = () => {
  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "50px" }}>
      <Typography variant="h2" color="error">
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Oops! The page you're looking for doesn't exist.
      </Typography>
      <Typography variant="body1" color="textSecondary">
        The link may be broken, or the page may have been removed.
      </Typography>

      <Box mt={3}>
        <Button variant="contained" color="primary" component={Link} to="/">
          Go Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default Page404;
